import { render, staticRenderFns } from "./TptCheckingFilter.vue?vue&type=template&id=965770fa&scoped=true"
import script from "./TptCheckingFilter.vue?vue&type=script&lang=js"
export * from "./TptCheckingFilter.vue?vue&type=script&lang=js"
import style0 from "./TptCheckingFilter.vue?vue&type=style&index=0&id=965770fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965770fa",
  null
  
)

export default component.exports